export const UPDATE_EXISTING_PRODUCTS = 'UPDATE_EXISTING_PRODUCTS';

export const actionMap = {
  [UPDATE_EXISTING_PRODUCTS]: (state, { updateExistingProducts }) => {
    return {
      ...state,
      updateExistingProducts,
    };
  },
};

export const initialState = {
  updateExistingProducts: true,
};
